import React, { useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import storage from '../utils/storage';
import classNames from 'classnames';
import { isAdminRole } from '../utils/mics';

const Sidebar = () => {

    const userInfo = useMemo(() => JSON.parse(storage.get('loginUser')), []);
    let navigate = useNavigate();
  
    if (!userInfo) { 
        navigate("/login", { replace: true });
    }
    
    const { userRole, userId, siteId } = userInfo || {};

    const location = useLocation(); // This hook gives access to the current route

    const links = [
        { to: '/ui/task', icon: 'pi pi-clipboard', label : "Messages" },
    ];

    return (
        <div className="team-sidebar">
            {links.map((link, index) => {
                const isActive = location.pathname === link.to; // Determine if this link is active
                return (
                    <SidebarLink
                        key={index}
                        to={link.to}
                        icon={link.icon}
                        active={isActive}
                        label={link.label}
                    />
                );
            })}

            {/* Render admin links if the user has an admin role */}
            {isAdminRole(userRole) && (
                <>
                    <SidebarLink to="/ui/chat-interface" icon="pi pi-comments" active={location.pathname === "/ui/chat-interface"} label="Chat" />
                    <SidebarLink to="/ui/users" icon="pi pi-user" active={location.pathname === "/ui/users"} label="User Management" />
                    <SidebarLink to="/ui/sites" icon="pi pi-shop" active={location.pathname === "/ui/sites"} label="Site Management"/>
                    <SidebarLink to="/ui/site-group" icon="pi pi-sitemap" active={location.pathname === "/ui/site-group"} label="Site Group Management"/>
                    <SidebarLink to="/ui/prop-confg" icon="pi pi-cog" active={location.pathname === "/ui/prop-confg"} label="Prop Config Management"/>
                    <SidebarLink to="/ui/task-notification" icon="pi pi-bell" active={location.pathname === "/ui/task-notification"} label="Task Notification Report"/>
                </>
            )}
        </div>
    );

};

const SidebarLink = ({ to, icon, active, label }) => (
    <div className={classNames('sidebar-item', { active })}>
        <Link to={to} className="p-button-text text-center">
            <div className="d-flex flex-column justify-content-center">
                <i className={icon}></i> 
                <p className='nav-title'>{label}</p>
            </div>
        </Link>
    </div>
);


export default Sidebar;
